import { useState } from "react";
import { Link } from "react-router-dom";

function FAQPreview({
  title,
  faqs,
  more = true,
  maxWidthCard = false,
  ctaText,
  toggleAlt = {},
}) {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleCard = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-preview">
      {/* Row 1: Title (Now conditionally rendered) */}
      {title && <h2 className="faq-preview-title">{title}</h2>}

      {/* Row 2+: Cards */}
      <div className="faq-preview-cards">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={index}
              className={`faq-preview-card ${isOpen ? "open" : "closed"} ${
                maxWidthCard ? "max-width" : ""
              }`}
              onClick={() => toggleCard(index)}
            >
              <div className="faq-card-header">
                <h3 className="faq-card-title">{faq.title}</h3>
                <img
                  src={`${process.env.PUBLIC_URL}/images/icons/${
                    isOpen ? "close_dark_blue.svg" : "open_light_blue.svg"
                  }`}
                  alt={isOpen ? toggleAlt.close || "" : toggleAlt.open || ""}
                  className="faq-card-icon"
                />
              </div>
              {isOpen && (
                <p className="faq-card-description">{faq.description}</p>
              )}
            </div>
          );
        })}
      </div>

      {/* Row 3: CTA Button */}
      {more && ctaText && (
        <Link to="/faq" className="cta-button secondary">
          {ctaText}
        </Link>
      )}
    </div>
  );
}

export default FAQPreview;
